<template>
  <div>
    <el-dialog
      title="导出"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="true">
      <div class="export-dialog-content">
        <!-- 批量导出按钮 -->
        <div class="export-actions">
          <el-button 
            type="primary" 
            size="mini"
            :disabled="selectedRows.length === 0"
            @click="handleBatchExport">
            批量导出
          </el-button>
        </div>
        
        <!-- 表格区域 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          max-height="400"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
            align="center">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center">
          </el-table-column>
          <el-table-column
            prop="tagName"
            label="标签名称"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="waveformCount"
            label="波形数量"
            align="center">
          </el-table-column>
        </el-table>
        
        <!-- 分页区域 -->
        <div class="export-pagination" v-if="filteredTotal > 0">
          <PageButton
            :total="filteredTotal"
            :page-size="pagination.size"
            :current-page="pagination.current"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange">
          </PageButton>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" type="primary">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 导出成功提示弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="successDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :show-close="false"
      class="success-dialog">
      <div class="success-content">
        <i class="el-icon-success success-icon"></i>
        <p class="success-message">下载成功！请至<span class="task-center-link" @click="handleJumpToTaskCenter"> 任务中心 </span>查看下载任务</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSuccessDialogClose">我知道了</el-button>
        <el-button type="primary" @click="handleJumpToTaskCenter">立即跳转</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageButton from '@/components/buttons/PageButton.vue'
import { waveformNpyResolveEExecDownZipTask } from '@/api/waveform/manage'

export default {
  name: 'ExportDialog',
  components: {
    PageButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        size: 20,
        total: 0
      })
    },
    dictItemInfo: {
      type: Object,
      default: () => ({
        dictItemId: '',
        dictItemName: '',
        dictItemCode: ''
      })
    }
  },
  data() {
    return {
      loading: false,
      selectedRows: [],
      successDialogVisible: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    tableData() {
      return this.dataList.filter(item => item.waveformCount > 0)
    },
    filteredTotal() {
      return this.dataList.filter(item => item.waveformCount > 0).length
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    
    async handleBatchExport() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      
      try {
        this.loading = true
        
        const waveformTagIds = this.selectedRows.map(row => row.id)
        
        const params = {
          dictItemId: this.dictItemInfo.dictItemId,
          dictItemName: this.dictItemInfo.dictItemName,
          dictItemCode: this.dictItemInfo.dictItemCode,
          waveformTagIds: waveformTagIds
        }
          this.$emit('batchExport', this.selectedRows)
        
        const res = await waveformNpyResolveEExecDownZipTask(params)
        
        if (res.code === 200) {
          this.$emit('batchExport', this.selectedRows)
          this.successDialogVisible = true
        }
      } catch (error) {
        console.error('批量导出失败:', error)
        this.$message.error('批量导出失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    handleSuccessDialogClose() {
      this.successDialogVisible = false
      this.dialogVisible = false
    },
    
    handleJumpToTaskCenter() {
      this.successDialogVisible = false
      this.dialogVisible = false
      this.$emit('jumpToTaskCenter')
    },
    
    handlePageChange(page) {
      this.$emit('pageChange', page)
    },
    
    handleSizeChange(size) {
      this.$emit('sizeChange', size)
    },
    
    handleConfirmExport() {
      this.$emit('confirm')
    },
    
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.export-dialog-content {
  /* min-height: 450px; */
}

.export-actions {
  margin-bottom: 15px;
}

.export-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.export-dialog-content >>> .el-table th {
  background-color: #fafafa !important;
}

.el-button:disabled{
  opacity: 0.4;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
}

.success-icon {
  font-size: 60px;
  color: #67c23a;
  margin-bottom: 20px;
}

.success-message {
  font-size: 16px;
  color: #303133;
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

.task-center-link {
  color: #00d8c3;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  transition: color 0.3s ease;
}

.task-center-link:hover {
  color: #139aa5;
}
</style>
